<template>
  <div class="feedback-container">
    <el-row :gutter="10">
      <el-col
        :span="12"
        class="box-left"
        style="overflow-y: auto;height: calc(100vh - 100px);overflow-x: hidden;"
      >
        <el-form
          ref="formData"
          :model="formData"
          label-position="top"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="原始订单编号" prop="orderNo">
                <el-input disabled v-model="formData.orderNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="调度订单编号" prop="dispatchOrderNo">
                <el-input
                  disabled
                  v-model="formData.dispatchOrderNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="反馈时间" prop="logTime">
                <el-date-picker
                  v-model="formData.logTime"
                  type="datetime"
                  placeholder="请选择反馈时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width:100%;"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="司机信息" prop="driverName">
                <dict-select
                  v-model="formData.driverName"
                  clearable
                  :disabled="driverNameVisible"
                  url="/master/driver/info/select"
                  placeholder="请选择司机"
                  filterable
                  :selectedLabel.sync="formData.driverName"
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="省/市/区县" prop="cityCode">
                <region-cascader
                  :show="true"
                  :props="{ checkStrictly: true }"
                  :provinceCode.sync="formData.provinceCode"
                  :provinceName.sync="formData.provinceName"
                  :cityCode.sync="formData.cityCode"
                  :cityName.sync="formData.cityName"
                  :districtCode.sync="formData.districtCode"
                  :districtName.sync="formData.districtName"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="实时地点" prop="logPlace">
                <el-input
                  v-model="formData.logPlace"
                  placeholder="请输入实时地点"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-map-location"
                    @click="openCoordPickerDialog()"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上报客户" prop="isSendCustomer">
                <el-select
                  style="width:100%"
                  v-model="formData.isSendCustomer"
                  placeholder="请选择是否是上报客户"
                >
                  <el-option label="是" value="Y" />
                  <el-option label="否" value="N" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="节点标题" prop="logTitle">
                <dict-select
                  clearable
                  v-model="formData.logTitle"
                  placeholder="请选择节点标题"
                  default
                  filterable
                  size="small"
                  style="width:100%"
                  :body="logTitleDictParams"
                >
                </dict-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="反馈内容" prop="logDesc">
            <el-input
              v-model="formData.logDesc"
              type="textarea"
              :rows="4"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈图片">
            <div class="feedback-log">
              <el-upload
                ref="uploader"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                :on-change="onImageChange"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="onImagePreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      class="el-upload-list__item-delete"
                      @click="onImageRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </div>
          </el-form-item>

          <div class="d-flex justify-content-end mb-4">
            <el-button type="primary" :loading="saveLoading" @click="save"
              >保存</el-button
            >
          </div>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-timeline style="overflow-y: auto;height: calc(100vh - 100px);">
          <el-timeline-item
            icon="el-icon-circle-check"
            type="primary"
            size="large"
            placement="top"
            v-for="(log, index) in logs"
            :key="index"
            :timestamp="log.logTime"
          >
            <span style="font-size:18px">{{ log.logTitleName }} </span><br />
            <span
              >客服{{ log.createByName }}反馈，实时地点：{{
                log.logPlace
              }}，司机：{{ log.driverName }}</span
            ><br />
            <span>反馈内容：{{ log.logDesc }}</span>
            <div>
              <swiper
                v-viewer="{ movable: true }"
                @click="imageView"
                class="swiper"
                ref="swiper"
                :options="swiperOption"
              >
                <swiper-slide v-for="(image, index) in log.imgs" :key="index">
                  <el-image
                    style="width:100%;height:100px;"
                    class="images"
                    :src="$osscdn(image.imageUrl)"
                  />
                </swiper-slide>
              </swiper>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-if="!logs || !logs.length"
            size="large"
            icon="el-icon-warning-outline"
          >
            暂无反馈信息
          </el-timeline-item>
        </el-timeline>
      </el-col>
    </el-row>
    <div v-show="false" class="uploadImages" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in feedbackLogImages"
        :src="item.url || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>

    <coord-picker-dialog
      v-if="coordPickerDialogVisible"
      :visible.sync="coordPickerDialogVisible"
      :address.sync="formData.logPlace"
      :longitude.sync="formData.logLongitude"
      :latitude.sync="formData.logLatitude"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      logTitleDictParams: { type: 'logTitle' },
      viewer: null,
      driverNameVisible: true,
      coordPickerDialogVisible: false,
      saveLoading: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      formData: {
        waybillCode: this.params.waybillCode,
        dispatchOrderCode: this.params.dispatchOrderCode,
        dispatchOrderNo: this.params.dispatchOrderNo,
        orderCode: this.params.orderCode,
        orderNo: this.params.orderNo,
        driverName: this.params.driverName
      },
      rules: {
        logTime: [
          { required: true, message: '请选择反馈时间', trigger: 'change' }
        ],
        isSendCustomer: [
          { required: true, message: '请选择上报客户', trigger: 'change' }
        ],
        cityCode: [
          {
            required: true,
            message: '请至少选择到城市',
            trigger: 'change'
          }
        ]
      },
      logs: [],
      feedbackLogImages: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.formData.dispatchOrderCode) return
      this.$api
        .carriageWaybillLogListApi({
          dispatchOrderCode: this.formData.dispatchOrderCode
        })
        .then((res) => {
          this.logs = res.body.data
        })
      if (this.formData.driverName === '') {
        this.driverNameVisible = false
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      this.saveLoading = true
      const feedbackLogImages = await this.uploadImages()
      this.formData.imgs = feedbackLogImages
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$api
        .carriageWaybillLogSaveApi(this.formData)
        .then(() => {
          loadingInstance.close()
          this.saveLoading = false
          // 重载列表数据
          this.getData()
        })
        .catch(() => ((this.saveLoading = false), loadingInstance.close()))
      this.formData.logTime = ''
      this.formData.logPlace = ''
      this.formData.isSendCustomer = ''
      this.formData.logDesc = ''
      if (this.params.driverName === '') {
        this.formData.driverName = ''
      }

      this.clearFiles()
    },

    saveCoord() {
      this.coordPickerDialogVisible = false
    },
    /**
     * 上传图片
     * @return 上传成功后的图片信息
     */
    uploadImages() {
      if (!this.feedbackLogImages || !this.feedbackLogImages.length) {
        return Promise.resolve([])
      }

      const uploadTask = this.feedbackLogImages.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          imageCode: res.body.id,
          imageUrl: res.body.url
        }))
      })

      return Promise.all(uploadTask)
    },

    onImageChange(file, fileList) {
      this.feedbackLogImages = fileList
    },
    onImageRemove(file) {
      this.$refs.uploader.handleRemove(file)
    },

    onImagePreview(file) {
      // 获取图片下标
      const index = this.feedbackLogImages.findIndex((i) => {
        return i.uid == file.uid
      })
      // 点击大图显示图片预览组件
      if (this.feedbackLogImages.length > 0) {
        this.viewer = this.$el.querySelector('.uploadImages').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    //清空已上传的文件列表
    clearFiles() {
      this.$refs['uploader'].clearFiles()
    },

    openCoordPickerDialog() {
      this.coordPickerDialogVisible = true
    },
    imageView() {
      // 点击大图显示图片预览组件
      this.viewer = this.$el.querySelector('.images').$viewer
    }
  }
}
</script>
